<div class="toolbar-dock fixed bottom-0 left-0 w-full">
  <div class="flex justify-center">
  <div class="flex gap-4 toolbar-dock__item-container">
    @for(item of items; track item.label) {
    <button class="toolbar-dock__item" (click)="item.command()">
      <cw-icon [svgId]="item.icon" />
      <span>{{item.label}}</span>
    </button>
    }
  </div>
  </div>

</div>
